import { isAdmin, isClient } from "./roles";

// The admin login lives at /admin. Clients never see it: they come in through
// the landing page at / and sign in with their client number and ID number.
// Kept in one place because six call sites have to agree on it.
export const ADMIN_LOGIN = "/admin";

/**
 * Where a role lands after signing in. Staff cannot open the finance
 * dashboard, so sending them there bounced them straight back to the login
 * form and read as a login that had failed.
 * @param {string} role The role from the login response
 * @return {string} Path to send them to
 */
export const homeForRole = (role) => {
  if (isClient(role)) {
    return "/my-profile";
  }
  if (isAdmin(role)) {
    return "/dashboard";
  }
  return "/clients-dashboard";
};
